/* Theme JS — variant picker, gallery, AJAX cart, drawer, filters */

(function () {

  /* =========================================
   * Product page: thumbnail clicks
   * ========================================= */
  const mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const full = thumb.dataset.full;
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.srcset = '';
      }
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* =========================================
   * Product page: variant selector sync
   * ========================================= */
  const form = document.querySelector('[data-product-form]');
  if (form) {
    const variantInput = form.querySelector('[data-variant-id-input]');
    const selectors = form.querySelectorAll('[data-option-selector]');
    const submitBtn = form.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('.product-price-row .price');
    const oldPriceEl = document.querySelector('.product-price-row .old');

    let productData = null;
    try {
      productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    } catch (e) {
      productData = null;
    }

    function updateVariant() {
      if (!productData) return;
      const chosen = Array.from(selectors).map((s) => s.value);
      const match = productData.variants.find((v) =>
        v.options.every((opt, i) => opt === chosen[i])
      );
      if (!match) return;

      variantInput.value = match.id;

      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (oldPriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          oldPriceEl.style.display = '';
          oldPriceEl.textContent = formatMoney(match.compare_at_price);
        } else {
          oldPriceEl.style.display = 'none';
        }
      }

      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }

    selectors.forEach((s) => s.addEventListener('change', updateVariant));
  }

  /* =========================================
   * AJAX add-to-cart + drawer
   * ========================================= */
  const drawer = document.getElementById('cart-drawer');
  const drawerBody = drawer && drawer.querySelector('[data-drawer-body]');
  const drawerFoot = drawer && drawer.querySelector('[data-drawer-foot]');
  const drawerSubtotal = drawer && drawer.querySelector('[data-cart-subtotal]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) =>
      el.addEventListener('click', closeDrawer)
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // Header cart icon opens drawer (preventDefault on cart link)
  document.querySelectorAll('.icon-btn.cart').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      refreshCart().then(openDrawer);
    });
  });

  // Intercept product form submit -> AJAX add
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submit = form.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = true;
        submit.dataset.originalText = submit.textContent;
        submit.textContent = 'Adding…';
      }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await refreshCart();
        openDrawer();
      } catch (err) {
        alert('Could not add to cart. Please try again.');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = submit.dataset.originalText || 'Add to cart';
        }
      }
    });
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (e) {}
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }

    drawerBody.innerHTML = cart.items
      .map(
        (item) => `
        <div class="drawer-item" data-key="${item.key}">
          <a href="${item.url}" class="drawer-item-img">
            ${item.image ? `<img src="${item.image.replace('.jpg', '_200x.jpg').replace('.jpeg', '_200x.jpeg').replace('.png', '_200x.png').replace('.webp', '_200x.webp')}" alt="${escapeHtml(item.product_title)}">` : ''}
          </a>
          <div class="drawer-item-info">
            <a href="${item.url}" class="drawer-item-title">${escapeHtml(item.product_title)}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
            <div class="drawer-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="drawer-item-qty">
              <button type="button" data-qty-change="-1" data-key="${item.key}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-change="1" data-key="${item.key}" aria-label="Increase">+</button>
              <button type="button" class="drawer-item-remove" data-qty-set="0" data-key="${item.key}">Remove</button>
            </div>
          </div>
        </div>`
      )
      .join('');

    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    if (drawerFoot) drawerFoot.hidden = false;
  }

  // Delegated handlers for qty changes in drawer
  if (drawerBody) {
    drawerBody.addEventListener('click', async (e) => {
      const changeBtn = e.target.closest('[data-qty-change]');
      const setBtn = e.target.closest('[data-qty-set]');
      if (!changeBtn && !setBtn) return;

      const itemEl = e.target.closest('.drawer-item');
      const key = (changeBtn || setBtn).dataset.key;
      const currentQty = parseInt(itemEl.querySelector('.drawer-item-qty span').textContent, 10);

      let newQty;
      if (setBtn) {
        newQty = parseInt(setBtn.dataset.qtySet, 10);
      } else {
        newQty = currentQty + parseInt(changeBtn.dataset.qtyChange, 10);
      }
      if (newQty < 0) newQty = 0;

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty }),
        });
        await refreshCart();
      } catch (e) {}
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
        { duration: 280 }
      );
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  /* =========================================
   * Collection filters: live submit on change
   * ========================================= */
  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', () => filterForm.submit());
  }

  // Mobile filter toggle
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('.filters');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      filterPanel.classList.toggle('open');
    });
  }

  // Initialize drawer with current cart on load
  refreshCart();

  /* =========================================
   * Search overlay + predictive search
   * ========================================= */
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput = searchOverlay && searchOverlay.querySelector('[data-search-input]');
  const searchResults = searchOverlay && searchOverlay.querySelector('[data-search-results]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  if (searchOverlay) {
    searchOverlay.querySelectorAll('[data-search-close]').forEach((el) =>
      el.addEventListener('click', closeSearch)
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) closeSearch();
    });
  }

  // Header search icon opens overlay
  document.querySelectorAll('a[href$="/search"], .icon-btn[aria-label="Search"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (!searchOverlay) return;
      e.preventDefault();
      openSearch();
    });
  });

  // Debounced predictive search
  let searchTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        searchResults.innerHTML = '<p class="search-hint">Start typing to see products.</p>';
        return;
      }
      searchTimer = setTimeout(() => runPredictiveSearch(q), 200);
    });
  }

  async function runPredictiveSearch(query) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      renderPredictiveResults(products, query);
    } catch (err) {
      searchResults.innerHTML = '<p class="search-hint">Search is temporarily unavailable.</p>';
    }
  }

  function renderPredictiveResults(products, query) {
    if (!products.length) {
      searchResults.innerHTML = `<p class="search-hint">No products match "${escapeHtml(query)}". <br/>Try a broader term.</p>`;
      return;
    }
    searchResults.innerHTML = `
      <div class="search-results-list">
        ${products.map((p) => `
          <a href="${p.url}" class="search-result">
            <div class="search-result-img">
              ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
            </div>
            <div class="search-result-info">
              <div class="search-result-title">${escapeHtml(p.title)}</div>
              ${p.vendor ? `<div class="search-result-vendor">${escapeHtml(p.vendor)}</div>` : ''}
              <div class="search-result-price">${p.price ? p.price : ''}</div>
            </div>
          </a>
        `).join('')}
      </div>
      <a href="/search?q=${encodeURIComponent(query)}" class="search-all-link">See all results for "${escapeHtml(query)}" →</a>
    `;
  }

  /* =========================================
   * Product recommendations (async section render)
   * ========================================= */
  const recsEl = document.querySelector('[data-product-recommendations]');
  if (recsEl && recsEl.dataset.productId) {
    const productId = recsEl.dataset.productId;
    const limit = recsEl.dataset.limit || 4;
    const intent = recsEl.dataset.intent || 'related';
    const url = `${window.routes && window.routes.product_recommendations_url || '/recommendations/products'}?section_id=product-recommendations&product_id=${productId}&limit=${limit}&intent=${intent}`;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html.trim();
        const fresh = wrapper.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          recsEl.innerHTML = fresh.innerHTML;
        }
      })
      .catch(() => {});
  }
})();
